import { API } from '@/shared/api/modules';
import type { GetOverallOccupancyRequestDto } from '@/shared/api/modules/facilities';
import { queryOptions } from '@tanstack/react-query';

export const getOverallOccupancyQueryOptions = (
  params: GetOverallOccupancyRequestDto
) =>
  queryOptions({
    queryKey: ['overall-occupancy', params],
    queryFn: async ({ signal }) => {
      const response = await API.facilities.getOverallOccupancy(params, {
        signal,
      });

      return {
        ...response,
        occupancy: { ...response.occupancy },
      };
    },
    enabled: !!params.from && !!params.to,
  });
